import * as React from 'react';
import { sanitise } from '../../services/username';

import { TextField } from '@origin-digital/style-guide';

interface IProps {
  id: string;
  className?: string;
  label?: string;
  onChange?: (e: React.ChangeEvent<React.ReactNode>) => void;
  onBlur?: (e: React.ChangeEvent<React.ReactNode>) => void;
  value: string;
  error?: string;
  checkingUser?: boolean;
  placeholder?: string;
  disableIcon?: boolean;
  isUserNameCheckEnabled: boolean;
}

export const UsernameInput: React.FC<IProps> = ({
  id,
  className,
  error,
  onChange,
  onBlur,
  checkingUser,
  label,
  placeholder,
  value,
  disableIcon,
}) => {
  return (
    <TextField
      type="email"
      className={className}
      autoComplete="username"
      id={id}
      name={id}
      autoFocus={false}
      maxLength={100}
      markdown={true}
      error={error}
      label={label}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      disableIcon={disableIcon}
      spinner={checkingUser}
      autoCapitalize="off"
      spellCheck={false}
      // ordering the input last should fix the bug on
      // chrome where autofill sometimes renders the username
      // input as empty
      orderHiddenInputLast={true}
      transform={(v) => v && sanitise(v)}
      data-id="LoginStep2__username__input"
    />
  );
};
